export default __webpack_public_path__ + "static/media/arrow.c42f0d6c.svg";